import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); 
    z-index: 1000;
    transition: opacity 0.3s ease, z-index 0.3s ease-in-out;

    display: flex;
    justify-content: center;

    position: fixed;
    top: 0;
    left: 0;
`;

export const Content = styled.div`
    height: 90vh;
    width: 100%;
    transform: translateY(5%);
    transition: transform 0.3s ease-out 0.2s, opacity 0.3s ease-out 0.2s;

    max-width: 768px;
    background: #FFF;
    color: #535354;

    border-radius: 5px;
    padding: 33px;
    box-shadow: rgb(0 0 0 / 46%) 0px 5px 10px;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 900px) {
        width: 90%;
        height: 90%;
        border-radius: 0;
        padding: 20px;
    }
`;

export const Menu = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    svg{
        font-size: 25px;
        color: #7A05A7;
    }

    button{
        background: none;
        border: 0;
    }
`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:center;
    margin-bottom: 10px;
`;

export const ContainerStatus = styled.div`
   background-color: #E5E4E299;
   width: 100%;
   padding: 0.6rem;
   margin-top: 10px;
   margin-bottom: 10px;
   border-radius: 5px;
`;

export const TypeOfShopping = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;

    svg{
        font-size: 1.1rem;
        color: #7A05A7;
        margin-right: 0.3rem;
        font-size: 20px;
    }
`;

export const ProductsList = styled.ul`
    overflow-y: auto;
    overflow-x: hidden;
    list-style: none;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;

    &::-webkit-scrollbar-track {
        background-color: #D3D3D3;
    }

    &::-webkit-scrollbar {
        width: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: gray;
        border-radius: 4px;
    }

    div{
        display: flex;
        .circle{
            background: #C3C3C3;
            margin-right: 10px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    
    .item{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .sublist{
        list-style: none;
        margin-left: 0.2rem;
        font-size:14px;
    }
`;

export const PaymentContainer = styled.div`
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;

    p{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }
`;

export const PaymentMethodContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    margin-top: 10px;
    margin-bottom: 10px;

    svg{
        margin-right: 5px;
        color: #7A05A7;
    }
`;

export const AddressContainer = styled.div`
    width: 100%;
    margin-top: 10px;
`;

export const Divisor = styled.hr`
    width: 100%;
    height: 2px;
    background: #ccc;
    margin-top: 5px;
    margin-bottom: 5px;
`;